import React from 'react';
import { useSelector } from 'react-redux';
import useArticlesStats from './ArticlesStatsHook';
import styles from './ArticlesStats.module.css';

const ArticlesStats = () => {
  const currCode = useSelector(
    (state) => state.user.publisher?.bookCurrency?.code
  );
  const { totalVisits, unlockedPosts, totalEarnings } = useArticlesStats();

  return (
    <section className={styles['articles-stats']}>
      <div className={styles['articles-stat__container']}>
        <span className={styles.label}>Total Visits</span>
        <span className={styles.stat}>{totalVisits}</span>
      </div>
      <div className={styles['articles-stat__container']}>
        <span className={styles.label}>Unlocked Posts</span>
        <span className={styles.stat}>{unlockedPosts}</span>
      </div>
      <div className={styles['articles-stat__container']}>
        <span className={styles.label}>Total Earning Till date</span>
        <span className={styles.stat}>
          {currCode}
          {'  '}
          {totalEarnings}
        </span>
      </div>
    </section>
  );
};

export default ArticlesStats;
